import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import styles from './styles/billable-kpis.module.scss';

const BillableKPIs = ({ enrolledUsers, enrolledUsersChange, invoiceAmount, invoiceAmountChange, nextInvoiceDue, nextInvoiceDueChange }) => {
    return (
        <div className={styles.kpiGrid}>
            <div className={styles.kpiCard}>
                <div className={styles.label}>Enrolled Users</div>
                <div className={styles.value}>{enrolledUsers.toLocaleString()}</div>
                <div className={styles.change}>
                    {enrolledUsersChange > 0 ? (
                        <>
                            <ArrowUpOutlined className={styles.iconUp} />
                            <span className={styles.percentUp}>{enrolledUsersChange}%</span>
                        </>
                    ) : enrolledUsersChange < 0 ? (
                        <>
                            <ArrowDownOutlined className={styles.iconDown} />
                            <span className={styles.percentDown}>{Math.abs(enrolledUsersChange)}%</span>
                        </>
                    ) : (
                        <span className={styles.percentNeutral}>0%</span>
                    )}
                    <span className={styles.period}>up from last month</span>
                </div>
            </div>

            <div className={styles.kpiCard}>
                <div className={styles.label}>Invoice Amount</div>
                <div className={styles.value}>${invoiceAmount.toLocaleString('en-US', { minimumFractionDigits: 2 })}</div>
                <div className={styles.change}>
                    {invoiceAmountChange > 0 ? (
                        <>
                            <ArrowUpOutlined className={styles.iconUp} />
                            <span className={styles.percentUp}>{invoiceAmountChange}%</span>
                        </>
                    ) : invoiceAmountChange < 0 ? (
                        <>
                            <ArrowDownOutlined className={styles.iconDown} />
                            <span className={styles.percentDown}>{Math.abs(invoiceAmountChange)}%</span>
                        </>
                    ) : (
                        <span className={styles.percentNeutral}>0%</span>
                    )}
                    <span className={styles.period}>up from last month</span>
                </div>
            </div>

            <div className={styles.kpiCard}>
                <div className={styles.label}>Next Invoice Due</div>
                <div className={styles.value}>{nextInvoiceDue}</div>
                <div className={styles.change}>
                    {nextInvoiceDueChange > 0 ? (
                        <>
                            <ArrowUpOutlined className={styles.iconUp} />
                            <span className={styles.percentUp}>{nextInvoiceDueChange}%</span>
                        </>
                    ) : nextInvoiceDueChange < 0 ? (
                        <>
                            <ArrowDownOutlined className={styles.iconDown} />
                            <span className={styles.percentDown}>{Math.abs(nextInvoiceDueChange)}%</span>
                        </>
                    ) : (
                        <span className={styles.percentNeutral}>0%</span>
                    )}
                    <span className={styles.period}>up from last month</span>
                </div>
            </div>
        </div>
    );
};

export default BillableKPIs;

